import { render, staticRenderFns } from "./Boton_Panico_Detalle.vue?vue&type=template&id=8cbeff58"
import script from "./Boton_Panico_Detalle.vue?vue&type=script&lang=js"
export * from "./Boton_Panico_Detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports